import { render } from "./AdPlacementTypeSelector.vue?vue&type=template&id=5b800e4f"
import script from "./AdPlacementTypeSelector.vue?vue&type=script&lang=js"
export * from "./AdPlacementTypeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__